const PREFIX = "ASH_CHECKLIST_";

export const save = (key: string, value: any) => {
  localStorage.setItem(PREFIX + key, JSON.stringify(value));
};

export const load = (key: string): any => {
  return JSON.parse(localStorage.getItem(PREFIX + key) as string);
};
